import { scheduleDeclarationComponent } from './schedule.declaration.component';
import { scheduleItemComponent } from './schedule.item.component';
import {loadNg1Module, ngmodule} from "../../bootstrap/ngmodule";
import {
    scheduleAvailabilityState,
    scheduleCalendarState,
    scheduleDeclarationState,
    scheduleListItemDeclarationState,
    scheduleListItemState,
    scheduleListState,
    scheduleShiftItemState,
    scheduleState,
    scheduleSubscriptionState,
} from './schedule.states';
import { scheduleComponent } from "./schedule.component";
import { scheduleCalendarComponent } from "./schedule.calendar.component";
import { scheduleListComponent } from "./schedule.list.component";
import { subscriptionItemComponent } from "./subscription.component";


const scheduleAppModule: aboTheme.INgModule = {
  components: { scheduleComponent, scheduleCalendarComponent, scheduleListComponent, subscriptionItemComponent, scheduleItemComponent, scheduleDeclarationComponent },
  states: [ scheduleState, scheduleCalendarState, scheduleListState, 
            scheduleDeclarationState, scheduleAvailabilityState, scheduleSubscriptionState,
            scheduleShiftItemState, scheduleListItemState, scheduleListItemDeclarationState ],

};

loadNg1Module(ngmodule, scheduleAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/schedule/index.ts